// Lib
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  retryButtonText: { fontSize: 14 },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    columnGap: theme.spacing(5),
    marginBottom: theme.spacing(2),
    '& > div': {
      flexBasis: 'calc(50% - 20px)',
    },
    [theme.breakpoints.down('lg')]: {
      borderBottom: `1px solid ${theme.palette.grey1}`,
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'initial',
      flexBasis: 'initial',
      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        fontWeight: 700,
      },
      '& .MuiRadio-colorPrimary': {
        paddingLeft: 1,
      },
      '& > div': {
        flexBasis: 'initial',
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        borderBottom: `1px solid ${theme.palette.grey1}`,
        flexDirection: 'column',
        gap: 0,
        justifyContent: 'initial',
        flexBasis: 'initial',
        '& .MuiFormControlLabel-label': {
          fontSize: 14,
          fontWeight: 700,
        },
        '& .MuiRadio-colorPrimary': {
          paddingLeft: 1,
        },
        '& > div': {
          flexBasis: 'initial',
        },
      }),
    },
  },
  enteredAddress: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControlLabel: {
    color: theme.palette.darkGrey,
    [theme.breakpoints.down('lg')]: {
      alignItems: 'start',
      maxHeight: 'fit-content',
      marginLeft: '-2px',
      '& .MuiFormControlLabel-label': {
        paddingTop: '3px',
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        alignItems: 'start',
        maxHeight: 'fit-content',
        marginLeft: '-2px',
        '& .MuiFormControlLabel-label': {
          paddingTop: '3px',
        },
      }),
    },
  },
  formControlRadio: {
    position: 'relative',
    bottom: 9,
    [theme.breakpoints.down('lg')]: {
      paddingBottom: 0,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        paddingBottom: 0,
      }),
    },
  },
  buttons: {
    display: 'flex',
    gap: theme.spacing(1),
    '& button': {
      backgroundColor: '#F4F4F4',
      borderRadius: 4,
      maxHeight: 24,
      minWidth: 24,
      padding: 4,
      '&:hover': {
        backgroundColor: '#F4F4F4',
      },
    },
  },
  validatedAddress: {
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
      marginTop: '18px',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3),
        marginTop: '18px',
      }),
    },
  },
  retryButton: {
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        paddingLeft: 0,
      }),
    },
  },
}));
